import { useEffect } from 'react'

import { useDataBoxSelector } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  defaultSchoolYearDataReceiver,
  defaultSchoolYearSelection,
  orgsFilterSelection,
  schoolYearFilter,
  schoolYearFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const SchoolYearFilter = ({ id, pending }: Props) => {
  const orgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const visible = orgs.length === 1

  useEffect(() => {
    schoolYearFilterSelection.resetToDefault()
    if (visible) {
      schoolYearFilter.addDataReceiver(defaultSchoolYearDataReceiver)
      schoolYearFilter.dataReceive(orgs)
    } else {
      schoolYearFilter.resetToDefault()
    }
  }, [orgs, visible])

  if (!visible) return null
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Учебный год"
      header="Выбор учебного года"
      dataBoxData={schoolYearFilter as any}
      dataBoxSelection={schoolYearFilterSelection}
      defaultSelection={defaultSchoolYearSelection}
      pleaseSelectText="Нет данных"
      disabled={pending}
    />
  )
}
